const MONTHLY_UNITS_SOLD_UPDATE = 'bfb/monthly_units_sold/MONTHLY_UNITS_SOLD_UPDATE';

export default {
  MONTHLY_UNITS_SOLD_UPDATE,
};
